import { render, staticRenderFns } from "./OrderSkeleton.vue?vue&type=template&id=6c13a435&scoped=true&"
import script from "./OrderSkeleton.vue?vue&type=script&async=true&lang=js&"
export * from "./OrderSkeleton.vue?vue&type=script&async=true&lang=js&"
import style0 from "./OrderSkeleton.vue?vue&type=style&index=0&id=6c13a435&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c13a435",
  null
  
)

export default component.exports